import Vue from 'vue';
import Environment from '@videsk/environment';

const stage = process.env.NODE_ENV || 'production';

const stages = {
  production: () => new Environment('global', 'https://api.videsk.io', 'https://api.videsk.io'),
  development: () => new Environment('global', 'http://localhost:3030', 'http://localhost:3030', 'development'),
  testing: () => new Environment('global', 'http://localhost:3030', 'http://localhost:3030', 'testing'),
  staging: () => new Environment('global', 'https://api.videsk.io', 'https://api.videsk.io', 'staging'),
};

const signalingEnvironments = {
  production: () => new Environment('signaling', '', 'wss://exchange.videsk.io'),
  development: () => new Environment('signaling', '', 'ws://localhost:6060', 'development'),
  testing: () => new Environment('signaling', '', 'ws://localhost:6060', 'testing'),
  staging: () => new Environment('signaling', '', 'wss://exchange.videsk.io', 'staging'),
};

const monitor = {
  production: () => new Environment('monitor', 'https://rt.videsk.io'),
  development: () => new Environment('monitor', 'http://localhost:5050', 'development'),
  testing: () => new Environment('monitor', 'http://localhost:5050', 'testing'),
  staging: () => new Environment('monitor', 'https://rt.videsk.io', 'staging'),
};

const options = stages[stage]();

options.websocketOptions.params = {
  path: '/ws',
  forceNew: true,
  reconnection: true,
  reconnectionDelay: 500,
  reconnectionDelayMax: 600,
  transports: ['websocket'],
};

options.websocketOptions.namespaces = {
  monitor: 'live-monitor',
};

export const signalingOptions = signalingEnvironments[stage]();
export const monitorOptions = monitor[stage]();

Vue.prototype.$devOptions = options;
Vue.prototype.$signalingOptions = signalingOptions;
Vue.prototype.$monitorOptions = monitorOptions;

export default options;
